import styled from 'styled-components';
import HBClickable from '../../HBClickable/HBClickable';

export const ActionAreaButton = styled(HBClickable)`
    all: unset;
    cursor: pointer;

    &:hover, :focus {
      all: unset;
    }

    &[disabled] {
        cursor: not-allowed;
    }

    &[data-is-empty="true"] {
      position: absolute;
      inset: 0;
    },
`;
